import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDisplayName(Component: React.ComponentType<React.PropsWithChildren<any>>): string {
  return Component.displayName || Component.name || 'Component';
}
